<template>
    <div class="container">
                <div class="page-header">
                    <div class="page-title">

                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li class="active">
                                  <router-link :title="'درجات السلوك والمواظبة'" :to="{name: 'attendDegrees'}"> درجات السلوك والمواظبة</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-12 col-md-12 layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">



                                <div class="row align-items-center">
                                    <div class="col-md-6">
                                        <h4>
                                            <i class="flaticon-computer-4"></i>
                                        إدارة درجات السلوك والمواظبة
                                        </h4>
                                    </div>
                                    <div class="col-md-6">
                                      <ul class="list-inline top-btns d-flex align-items-center m-0">
                                        <li class="list-inline-item">
<create-button  v-if="hasPermissions('attendDegrees_create')" :routeName="'attendDegrees.create'"></create-button>
</li>
                                        <li class="list-inline-item">
                                          <button class="search-btn-wg btn-creative btn-3 btn-3e flaticon-search-1
" v-if="searchingMode == 0" @click="searchingMode = 1"> <span>فلاتر البحث</span></button>
                                          <button class="btn btn-danger search-btn-wg mb-2 my-2 " v-if="searchingMode == 1" @click="searchingMode = 0">إغلاق X</button></li>



                                      </ul>

                                      </div>
                                </div>
                            </div>
                            <div class="widget-content widget-content-area">

                                <form @submit.prevent="getIndexData(1)" v-if="searchingMode == 1" style="border: 1px solid #DDD;padding: 20px" class="mb-4">
                                    <div class="form-row">
                                      <div :class="'col-md-' + (user.role == 'admin' ? '6' : '12')">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">الحلقة</label>
                                            <treeselect :options="lessons" v-model="data.searching.lesson_id" @select="getTeachers" :multiple="false"/>

                                        </div>
                                      </div>
                                      <div class="col-md-6"  v-if="user.role == 'admin'">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">المعلم</label>
                                            <treeselect :options="teachers" :auto-load-root-options="true" v-model="data.searching.teacher_id" :multiple="false"/>

                                        </div>
                                      </div>
                                        <div class="col-md-6 mt-2">
                                          <label for="">من تاريخ </label>
                                          <date-picker v-model="data.searching.date_from" :editable="true" :calendar="'hijri'"></date-picker>
                                        </div>
                                        <div class="col-md-6 mt-2">
                                          <label for="">إلى تاريخ </label>
                                          <date-picker v-model="data.searching.date_to" :editable="true" :calendar="'hijri'"></date-picker>
                                        </div>
                                        <div class="col-md-3 mt-5">
                                                                                                                <button type="submit" name="time" class="search-btn-wg btn-creative btn-3 btn-3e flaticon-search-1"> <span>بحث</span></button>

                                          <!-- <input type="submit" name="time" class=" btn btn-button-7 btn-block" value="بــــحــث"> -->
                                        </div>
                                    </div>
                                </form>

                                <div class="table-responsive">
                                  <div class="row mb-2">
                                      <div class="col-md-1">
                                        <span>إظهار</span>
                                        <select v-model="data.searching.perPage" @change="getIndexData(1)" class="form-control">
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                      </div>
                                    </div>

                                    <div class="col-md-12">
                                      <button @click.prevent="printTable" v-if="data.data.length" class="btn btn-success mt-2 mb-2">
                                        <i class="fa fa-print"></i> طباعة
                                      </button>
                                    </div>
                                    <div class="col-md-12" id="print-table">
                                          
                                        <table class="table table-bordered mb-4">
                                            <thead>
                                                <tr>
                                                  <th>
                                                      <a href="#" @click.prevent="resortData();">
                                                        <i class="flaticon-arrow-down-1" v-if="data.searching.sorting == 'asc'"></i>
                                                        <i class="flaticon-arrow-up" v-if="data.searching.sorting == 'desc'"></i>
                                                      </a>
                                                    </th>
                                                    <th @click="resortData();">الحلقة</th>
                                                    <th @click="resortData();"  v-if="user.role == 'admin'">المعلم</th>
                                                    <th @click="resortData();">التاريخ</th>
                                                    <th class="align-center">#</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, index) in data.data" :key="index">
                                                    <td>{{index+1}}</td>
                                                    <td>{{item.lesson.name}}</td>
                                                    <td  v-if="user.role == 'admin'">{{item.teacher.name}}</td>
                                                    <td>{{item.date_and_time}}</td>
                                                    <td class="text-center">

                                                        <div class="dropdown custom-dropdown">
                                                            <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                <i class="flaticon-dot-three fs-17"></i>
                                                            </a>

                                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuLink1">
                                                                <a href="#" class="dropdown-item" @click.prevent="print(item)">طباعة</a>
                                                                <edit-button v-if="hasPermissions('attendDegrees_edit')" :routing="{name: 'attendDegrees.edit', params: {id: item.id}}" :title="'تعديل'"></edit-button>
                                                                <delete-button v-if="hasPermissions('attendDegrees_delete')" :deleteUrl="'/attendDegrees/' + item.id" :data="item" @deleteData="deleteData"></delete-button>
                                                            </div>
                                                        </div>

                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                  <th>
                                                      <a href="#" @click.prevent="resortData();">
                                                        <i class="flaticon-arrow-down-1" v-if="data.searching.sorting == 'asc'"></i>
                                                        <i class="flaticon-arrow-up" v-if="data.searching.sorting == 'desc'"></i>
                                                      </a>
                                                    </th>
                                                    <th @click="resortData();">الحلقة</th>
                                                    <th @click="resortData();"  v-if="user.role == 'admin'">المعلم</th>
                                                    <th @click="resortData();">التاريخ</th>
                                                    <th class="align-center">#</th>
                                                </tr>
                                            </tfoot>

                                        </table>
                                    </div>

                                </div>
                                <div class="row">
                                  <div class="col-md-4">
                                    <simple-pagination :data="data.paginated" @getIndexData="getIndexData($event)"></simple-pagination>
                                  </div>
                                  <div class="col-md-8 mt-4">
                                    <table-info v-if="Object.keys(data.paginated).length" :data="data.paginated"></table-info>
                                  </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

                  <div class="row" style="display: none;" id="printMe">
                <div class="col-md-12">

                   <table class="table table-bordered">
                    <tbody>
                    </tbody>
                    <tbody>
                        <tr class="text-left">
                                <td colspan="4">{{printData.date_and_time}}</td>
                            </tr>
                            <tr class="text-center">
                                <td colspan="4">{{printData.lesson.name}}</td>

                            </tr>
                            <tr class="text-right">
                                <td colspan="4">المعلم /{{printData.teacher.name}}</td>
                            </tr>
                        <tr >
                            <th>اسم الطالب</th>
                            <th>درجة السلوك</th>
                            <th>درجة المواظبة</th>
                            <th>درجة الزى</th>
                        </tr>

                        <tr  v-for="(st, k) in printData.attend_degree_students" :key="k">
                            <th>{{st.student_name}}</th>
                            <th>{{ st.behave_degree }}</th>
                            <th>{{ st.attend_degree }}</th>
                            <th>{{ st.dress_degree }}</th>
                        </tr>



                    </tbody>
                  </table>
                </div>
              </div>

            </div>


</template>
<script>
import VueDatetimeJs from 'vue-datetime-js'

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
export default {
    components: {
    datePicker: VueDatetimeJs,
    Treeselect
  },
  data() {
    return {
      teachers: [],
      lessons: [],
      data: {
        data: {},
        searching:{
            date_from: '',
            date_to: '',
            teacher_id: '',
            lesson_id: '',
            perPage: 10,
            sorting: 'desc'
        },
        paginated: {},
        showFilter: false,
      },
      searchingMode: 0,
      printData: {save_review_students: [], lesson: {}, teacher: {}}
    };
  },
  created(){
      this.flashAlert();
      this.getLessons();
      this.getIndexData(1);
  },
  methods: {
    resortData(){
        this.data.searching.sorting = this.data.searching.sorting == 'asc' ? 'desc' : 'asc';
        this.getIndexData(1);
    },
     getTeachers(val){
      this.data.searching.teacher_id = '';
      this.$baseApi.get('/attendDegrees?l=' + val.id).then((response)=>{
            if(response.data.code == 200){
               this.teachers = response.data.data.teachers;

            }
        });
    },
    printTable(){
      setTimeout(() => {
        this.print_element('print-table', 'درجات السلوك والمواظبة');
      }, 1000);
    },
    print(data){
      this.printData = data;
      setTimeout(() => {
        this.print_element('printMe', 'درجة سلوك ومواظبة');

      }, 3000);
    },
      getLessons(){
        this.$baseApi.get('/attendDegrees?basic_pluck=1').then((response)=>{
            if(response.data.code == 200){
               this.lessons = response.data.data.lessons;

            }
        });
      },
      getIndexData(page){
        this.$baseApi.get('/attendDegrees?page=' + page, {
                    params: this.data.searching
                }).then((response)=>{
            if(response.data.code == 200){
               this.data.paginated = response.data.data.attendDegrees;
               this.data.data = response.data.data.attendDegrees.data;

            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
      deleteData(data){
          this.data.data.splice(this.data.data.indexOf(data), 1);
      },
    clearFilter(items) {
      this.data.showFilter = !this.data.showFilter
      if (!this.data.showFilter) {
        for (const itemsKey in items) {
          this.data.searching[itemsKey] = ''
        }
        this.getIndexData(1);
      }
    }
  },
  computed: {
    user(){
      return this.$store.getters.SET_AUTH_USER;
    }
  }
};
</script>
<style>
</style>
